import ability from "./ability";
import { matchesAcl } from "@core/libs/acl/utils";

export const canNavigate = (to) => {
  return to.matched.some((route) => {
    return matchesAcl(
      (action, resource) => ability.can(action, resource),
      route.meta.action || "read",
      route.meta.resource,
    );
  });
};

export const _ = undefined;
